import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Card, CardBody, Col } from "reactstrap";
import { StockResultItems } from "../../../../../types/Tables";
import FilterComponent from "../common/FilterComponent";
import { StockResultTitle } from "../../../../../constants";
import { StockResultSubTitle, StockResultTableColumns, StockResultTableData } from "../../../../../data/formsAndTable/tables/dataTables/AdvanceInit";
import CommonCardHeader from "../../../../../coreComponents/CommonCardHeader";

const StockResult = () => {
  const [filterText, setFilterText] = useState("");
  const filteredItems: StockResultItems[] = StockResultTableData.filter((item: StockResultItems) => Object.values(item).some((value) => value && value.toString().toLowerCase().includes(filterText.toLowerCase())));
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader headClass="pb-0 card-no-border" title={StockResultTitle} span={StockResultSubTitle} />
        <CardBody>
          <FilterComponent onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} filterText={filterText} />
          <div className="table-responsive">
            <DataTable data={filteredItems} columns={StockResultTableColumns} striped={true} className="display custom-scrollbar" />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default StockResult;
